import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock1 as Block } from "./HomepageBlock1";
import { defaultData } from "./HomepageBlock1DefaultData";
import { meta } from "./HomepageBlock1MetaData";
import imagePreview from "./homepage_block_1_preview.png";

export const HomepageBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
